<template>
	<div>
		<p>{{txt.name}}: {{ $keycloak.fullName }}</p>
		<p>{{txt.username}}: {{ $keycloak.userName }}</p>
		<p>{{txt.email}}: {{ $keycloak.tokenParsed.email }}</p>
	</div>
</template>

<script>
export default {
	name: 'personalInfo',
	data() {
		return {
			txt: {
				name: 'Name',
				username: 'Username',
				email: 'E-Mail',
			},
		}
	},
}
</script>

<style>

</style>
